import { ReactNode, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useIsAdminOrModerator } from '@/hooks/useIsAdminOrModerator';
import { PageLoader } from '@/components/ui/brand-loader';

interface AdminRouteProps {
  children: ReactNode;
  /** Where to redirect if user has no elevated role (defaults to /dashboard) */
  redirectTo?: string;
}

/**
 * Route guard that restricts access to admin and moderator users.
 */
export function AdminRoute({
  children,
  redirectTo = '/dashboard'
}: AdminRouteProps) {
  const { isAdminOrMod, loading } = useIsAdminOrModerator();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (!loading) return;
    const timer = setTimeout(() => setTimedOut(true), 10000);
    return () => clearTimeout(timer);
  }, [loading]);

  if (loading && !timedOut) {
    return <PageLoader />;
  }

  if (timedOut || !isAdminOrMod) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
